import React, { createContext, useContext } from 'react';

export const GlobalDataContext = createContext();

export const useGlobalData = () => useContext(GlobalDataContext);

export const GlobalDataProvider = ({ children, value }) => (
  <GlobalDataContext.Provider value={value}>
    {children}
  </GlobalDataContext.Provider>
);
